<template>
  <CustomDeleteDialog
    dialogId="remove-single-resource-detail-section-from-resource"
    okTitle="حذف"
    :dialogTitle="`تایید حذف ${resourceDetailContentSectionTitle}`"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendRemoveRequest"
  >
    <p v-if="resourceDetailContentSection">
      آیا از حذف
      <span style="font-weight: bold !important">
        {{ resourceDetailContentSection.title }}
      </span>
      اطمینان دارید؟
    </p>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    resourceDetailContentSection: {
      type: Object,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendRemoveRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let removeResourceDetailContentSection =
          new RemoveResourceDetailContentSection(_this);
        removeResourceDetailContentSection.setRequestParam({
          resourceDetailContentSectionId: _this.resourceDetailContentSection.id,
        });

        await removeResourceDetailContentSection.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "بخش با موفقیت حذف شد.",
              },
            });
            _this.$emit("refetch");
            _this.$bvModal.hide(
              "remove-single-resource-detail-section-from-resource"
            );
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  computed: {
    resourceDetailContentSectionTitle() {
      if (
        this.resourceDetailContentSection &&
        this.resourceDetailContentSection.title
      ) {
        return this.resourceDetailContentSection.title;
      }
      return "";
    },
  },
  components: {
    CustomDeleteDialog,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { RemoveResourceDetailContentSection } from "@/libs/Api/Resources";
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
</script>
